module.exports = __webpack_public_path__ + "static/media/training_hero_mind_body_fitness.7f3181c9.webp";